import axios from "axios";
import { API, BASE_API } from "../../const";
import { normParam, serverTime } from "../../tools";
const M_API = API;
// import { normParam } from '@/tools'
// import Vue from 'vue'

const store = {
  namespaced: true,
  state: {
    user: null,
    syaratDialog: null,
    config: null,
    permission: [],
    roles: [],
    currentRole: null,
    meta: null,
    promiseRT: null,
    arrayOfRT: [],
    retryRefresh: true,
    kuesioner: []
  },
  getters: {
    user(state) {
      return state.user;
    },
    syaratDialog(state) {
      return state.syaratDialog;
    },
    permission(state) {
      return state.permission;
    },
    userMeta(state) {
      return state.meta ? state.meta.users_meta : null;
    },
    roles(state) {
      return state.roles;
    },
    currentRole(state) {
      return state.currentRole;
    },
    kuesioner(state) {
      return state.kuesioner;
    }
  },
  mutations: {
    setKuesioner(state, val) {
      state.kuesioner = val;
    },
    setSyaratDialog(state, val) {
      state.syaratDialog = val;
    },
    login(state, { user }) {
      state.user = user;
    },
    logout(state) {
      state.user = null;
      state.instansi_aktif = null;
      // state.role = null
      state.roles = [];
      state.permission = [];
    }
  },
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/user${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    syncAkun({}, {}) {
      return axios
        .get(`${M_API}/resync-simpkb`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    sekolah({}, { instansi_id }) {
      return axios
        .get(`${BASE_API}/gtk/instansi/${instansi_id}/sekolah-tugases-kepsek`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    ptk({}, { instansi_id, params }) {
      return axios
        .get(`${BASE_API}/gtk/instansi/${instansi_id}/anggota_ptk${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    cekSyaratPppk({}, { params }) {
      return (
        axios
          .get(`${BASE_API}/p3k/syarat_pendaftaran`)
          // .get("http://127.0.0.1:4010/p3k/syarat_pendaftaran")
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err))
      );
    },
    // eslint-disable-next-line
    getLayanan({}, {}) {
      return axios
        .get(`${API}/simpkb_layanan`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    berkas(_, obj) {
      if (obj.id) {
        let formData = new FormData();
        formData.append("nama_berkas", obj.nama_berkas);
        formData.append("jenis_berkas_id", obj.jenis_berkas.id);
        //jika ada berkas, isEdit tidak harus upload berkas
        if (obj.file) {
          formData.append("file", obj.file);
        }

        // Loop untuk menambahkan seluruh sasaran ke FormData
        for (let i = 0; i < obj.sasaran.length; i++) {
          const sasaranId = obj.sasaran[i].id;
          if (sasaranId !== undefined) {
            formData.append(`sasaran_ids[${i}]`, sasaranId);
          }
        }

        return axios.post(`${BASE_API}/gtk/berkas/${obj.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      } else {
        let formData = new FormData();
        formData.append("nama_berkas", obj.nama_berkas);
        formData.append("jenis_berkas_id", obj.jenis_berkas.id);
        formData.append("file", obj.file);

        // Loop untuk menambahkan seluruh sasaran ke FormData
        for (let i = 0; i < obj.sasaran.length; i++) {
          const sasaranId = obj.sasaran[i].id;
          formData.append(`sasaran_ids[${i}]`, sasaranId);
        }

        return axios.post(`${BASE_API}/gtk/berkas`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });
      }
    },

    cekBerkas(_, { instansi_id, paspor_id }) {
      return axios.get(`${BASE_API}/gtk/instansi/${instansi_id}/cek_berkas?paspor_id=${paspor_id}`).then(res => {
        return res.data;
      });
    },

    cekSyarat(_, { instansi_id, paspor_id }) {
      return axios.get(`${BASE_API}/gtk/instansi/${instansi_id}/cek_daftar_tpsd?paspor_id=${paspor_id}`).then(res => {
        return res.data;
      });
    },

    berkasDrop(_, item) {
      return axios.delete(`${BASE_API}/gtk/berkas/${item.id}`).then(res => {
        return res.data;
      });
    },

    // eslint-disable-next-line
    getBerkas({}, { params }) {
      return axios
        .get(`${BASE_API}/gtk/berkas${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getTautan({}, {}) {
      return axios
        .get(`${API}/simpkb_tautan`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    searchPPPK({}, email) {
      return axios
        .get(`${BASE_API}/p3k/getkelas/${email}`)
        .then(res => {
          res.data.enrol_kelas_p3k.forEach(kelas => {
            kelas.server_time = serverTime(res);
          });
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    search({}, email) {
      return axios
        .get(`${M_API}/user/email/${email}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getPengelola({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/user-peran${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKandidatPengelola({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/user/kandidat-pengelola${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getJadwal({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/kelas_publik${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPeran({}, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/peran`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getJenjang({}) {
      return axios
        .get(`${M_API}/jenjang`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getSertifikat({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/sertifikat${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    regenSertifikatPiagam({}, { instansi_id, nomor_sertifikat }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/regenerate_sertifikat/${nomor_sertifikat}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    cekUpdateJenjang({}, instansi_id) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/update-jenjang`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getPiagam({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/piagam${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    cetakPiagam({}, url) {
      var tempName = url.split("/");
      var filename = tempName[tempName.length - 1];
      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf"
        }
      })
        .then(res => (res.ok ? res.blob() : Promise.reject(res)))
        .then(res => {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filename}`);
          document.body.appendChild(link);
          link.click();
          // eslint-disable-next-line
          window.URL.revokeObjectURL(url);
        })
        .catch(e => {
          let p = e.json ? e.json().then(a => Promise.reject(a)) : Promise.reject(e);
          return p;
        })
        .catch(e => {
          //Vue.prototype.$error(e.message);
          return Promise.reject(e);
        });
    },

    // eslint-disable-next-line
    cetakSertifikat({}, url) {
      var tempName = url.split("/");
      var filename = "Piagam " + tempName[tempName.length - 1];
      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf"
        }
      })
        .then(res => (res.ok ? res.blob() : Promise.reject(res)))
        .then(res => {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filename}`);
          document.body.appendChild(link);
          link.click();
          // eslint-disable-next-line
          window.URL.revokeObjectURL(url);
        })
        .catch(e => {
          let p = e.json ? e.json().then(a => Promise.reject(a)) : Promise.reject(e);
          return p;
        })
        .catch(e => {
          //Vue.prototype.$error(e.message);
          return Promise.reject(e);
        });
    },

    // eslint-disable-next-line
    getPenggunaDiklat({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/user${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detil({}, { instansi_id, diklat_id, user_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/user/${user_id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    profil({ state }) {
      return axios
        .get(`${M_API}/profilku`)
        .then(res => {
          state.user = {
            ...res.data
          };
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    cekPasspor(_, email) {
      return axios
        .get(`${M_API}/user-simpkb?email=${email}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    detail(_, user_id) {
      return axios.get(`${API}/users/${user_id}`).then(res => {
        return res.data;
      });
    },

    persetujuan(_, { instansi_id, kelas_id, data }) {
      return axios.post(`${BASE_API}/gtk/instansi/${instansi_id}/kelas_konfirmasi`, data).then(res => {
        return res.data;
      });
    },

    ajuan_perbaikan(_, { instansi_id, kelas_id, data }) {
      return axios.post(`${BASE_API}/gtk/registrasi_ulang`, data).then(res => {
        return res.data;
      });
    },

    link_password(_, data) {
      return axios.post(`${M_API}/link_password`, data).then(res => {
        return res.data;
      });
    },
    changePassword(_, data) {
      return axios.post(`${M_API}/ganti_password`, data).then(res => {
        return res.data;
      });
    },
    resetPassword(_, data) {
      return axios.post(`${M_API}/password`, data).then(res => {
        return res.data;
      });
    },
    //cek status pengisian kuesioner
    // eslint-disable-next-line
    cekKuesioner({ commit }, { params }) {
      // return axios
      //   .get(`${M_API}/ceksurvey${normParam(params)}`)
      //   .then(res => {
      //     commit("setKuesioner", res.data);
      //     return res.data;
      //   })
      //   .catch(err => Promise.reject(err));
      return;
    },
    // eslint-disable-next-line
    cekSyaratDialog({ commit }, {}) {
      return axios
        .get(`${M_API}/self-info`)
        .then(res => {
          commit("setSyaratDialog", res.data);
        })
        .catch(err => Promise.reject(err));
    },
    //counter faq
    getCounter() {
      return axios
        .get(`${M_API}/faq`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    setCounter(_, { instansi_id, key, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/faq/${key}?progress=false`, obj, {
          params: {
            progress: false
          }
        })
        .then(res => {
          return res.data;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    // create({}, { instansi_id, obj }) {
    //   if (obj.id) {
    //     return axios
    //       .put(`${M_API}/instansi/${instansi_id}/profil`, obj)
    //       .then(res => {
    //         return res;
    //       })
    //       .catch(err => Promise.reject(err));
    //   } else {
    //     return axios
    //       .post(`${M_API}/instansi/${instansi_id}/user/`, obj)
    //       .then(res => {
    //         return res;
    //       })
    //       .catch(err => Promise.reject(err));
    //   }
    // },
    // eslint-disable-next-line
    form({}, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/profil`, obj)
          .then(res => {
            return res;
          })
          .catch(err => Promise.reject(err));
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/user`, obj)
          .then(res => {
            return res;
          })
          .catch(err => Promise.reject(err));
      }
    },
    // eslint-disable-next-line
    create({}, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/profil`, obj)
          .then(res => {
            return res;
          })
          .catch(err => Promise.reject(err));
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/user-simpkb`, obj)
          .then(res => {
            return res;
          })
          .catch(err => Promise.reject(err));
      }
    },
    // eslint-disable-next-line
    biodata(_, obj) {
      return axios
        .post(`${M_API}/nik`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    register(_, obj) {
      return axios
        .post(`${M_API}/register`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${API}/users/${item.user_id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    login(
      { dispatch },
      // eslint-disable-next-line
      { grant_type, client_id, client_secret, username, password, instansi_id }
    ) {
      return axios
        .post(`${API}/oauth/token`, {
          grant_type,
          client_id,
          client_secret,
          username,
          password,
          instansi_id
        })
        .then(() => {
          return dispatch("fetch");
        })
        .catch(err => {
          Promise.reject(err);
          return err;
        });
    },
    // eslint-disable-next-line
    logout({ commit }) {
      // return axios.get(`${BASE_API}/logout`)
      //   .then(() => {
      //     commit('logout')
      //   })
      commit("logout");
      return Promise.resolve();
    },
    // eslint-disable-next-line
    fetch({ state, dispatch, commit }, mode) {
      // jika modenya reload get ulang state user
      if (mode == "reload") {
        return axios
          .get(`${M_API}/self`, {
            params: {
              progress: true
            }
          })
          .then(res => {
            state.user = {
              ...res.data,
              nama: res.data.name
            };
          });
      } else {
        if (state.user) {
          return Promise.resolve();
        } else {
          // state.user = { email: "test@test.com", nama: "Admin" };
          return axios
            .get(`${M_API}/self`, {
              params: {
                progress: true
              }
            })
            .then(res => {
              state.user = {
                ...res.data,
                nama: res.data.name
              };
            })
            .then(() => {
              return axios.get(`${M_API}/instansi`).then(res => {
                var seri = res.data.filter(s => s.subinstansi_count == 0);
                commit("instansi/setInstansis", seri, {
                  root: true
                });
              });
            });
        }
      }
    },
    // eslint-disable-next-line
    getPermission({ state }, instansi_id) {
      return axios
        .get(`${API}/instansi/${instansi_id}/akses`)
        .then(res => {
          state.permission = res.data;
        })
        .then(() => {
          // this.getPermission();
        });
    },
    // eslint-disable-next-line
    getRole({ state }, instansi_id) {
      return axios
        .get(`${API}/instansi/${instansi_id}/peranku`, {
          params: {
            progress: true
          }
        })
        .then(res => {
          state.roles = res.data;
          return res.data;
        });
    },
    // eslint-disable-next-line
    getPermissionByRole({ state }, { instansi_id, peran_id }) {
      return axios.get(`${API}/instansi/${instansi_id}/peran/${peran_id}`).then(res => {
        state.currentRole = res.data.keterangan;
        state.permission = [...res.data.akses];
        return state.permission;
      });
    }
  }
};

export default store;
